import React from "react";

export default ({isVisible = true}) => {
  return (
    (isVisible)
    ? <div className="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    : null
  )
}